import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import type { MultiProductBlock as MultiProductBlockValue } from "@reactivated";

import { interpolate } from "@thelabnyc/thelabui/src/utils/i18n";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { StarRatingStars } from "../StarRating";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: MultiProductBlockValue }>;

export const MultiProductBlock = (props: IProps): React.JSX.Element => {
    return (
        <section className="multi-product-block">
            <h1 className={styles.multiProductBlockHeader}>
                {props.value.header}
            </h1>
            <div
                className={styles.multiProductBlockCopy}
                dangerouslySetInnerHTML={{ __html: props.value.copy ?? "" }}
            ></div>
            <ul className={styles.multiProductBlockPanes}>
                {(props.value.products ?? []).map((product, index) => (
                    <li
                        className="multi-product__product-container"
                        key={index}
                    >
                        <img
                            src={product.image?.url}
                            className={styles.multiProductBlockPaneImage}
                            loading="lazy"
                            decoding="async"
                        />
                        <div className={styles.multiProductBlockProductTitle}>
                            {product.title}
                        </div>
                        <div
                            className="multi-product-block__product-copy"
                            dangerouslySetInnerHTML={{
                                __html: product.copy ?? "",
                            }}
                        ></div>
                        {(product.stars ?? 0) > 0 ? (
                            <div>
                                <StarRatingStars rating="" />
                            </div>
                        ) : null}
                        <a
                            className={concatClassNames([
                                styles.multiProductBlockButton,
                                "button",
                            ])}
                            href={product.product?.url}
                        >
                            {t`Shop Now`}
                        </a>
                        <div className={styles.multiProductBlockPricing}>
                            {interpolate(t`%(price)s each`, {
                                price: product.price,
                            })}
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
};
